function sortSizes(a, b) {
  // eslint-disable-next-line no-nested-ternary
  return (parseInt(a.sizes, 10) > parseInt(b.sizes, 10) ? 1 : (parseInt(a.sizes, 10) === parseInt(b.sizes, 10) ? 0 : -1));
}

export default sortSizes;
